<template>
  <v-container class="py-8 bg-light-blue-main">
      <v-btn flat @click="router.push('/')" class="no-background" style="background: none;" prependIcon="mdi-keyboard-backspace">{{ $t("views.profile.backToStart") }}</v-btn>
    <div class="mb-10">
        <h1 class="mb-5">Profil</h1>
      <v-card>
        <v-dialog v-model="dialog_adress">
          <InvoiceAdressView />
        </v-dialog>
        <v-card-text>
            <v-btn data-cy="change-address" @click="dialog_adress = true" class="mb-5">{{ $t("views.profile.changeAddress") }}</v-btn>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="first_name"
                label="Vorname"
                style="margin-bottom: 10px" />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="last_name"
                label="Nachname"
                style="margin-bottom: 10px" />
            </v-col>
            <v-col cols="6">
              <v-text-field
                value="*************"
                readonly
                class="no-pointer" />
            </v-col>
            <v-col cols="6">
              <v-btn @click="dialogChangePassword = true">{{
                $t("views.profile.changePassword")
              }}</v-btn>
              <v-dialog v-model="dialogChangePassword">
                <v-card>
                  <v-card-title>{{
                    $t("views.profile.changePassword")
                  }}</v-card-title>
                  <v-card-text>
                    <v-text-field
                      v-model="oldPassword"
                      label="Altes Passwort"
                      type="password"
                      style="margin-bottom: 10px" />
                    <v-text-field
                      v-model="newPassword"
                      label="Neues Passwort"
                      type="password"
                      style="margin-bottom: 10px" />
                    <v-text-field
                      v-model="confirmPassword"
                      label="Passwort bestätigen"
                      type="password"
                      style="margin-bottom: 10px" />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="changePassword(false)">{{
                      $t("views.profile.cancel")
                    }}</v-btn>
                    <v-btn @click="changePassword(true)">{{
                      $t("views.profile.save")
                    }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <DeleteWithConfirmationButton
            message="delete-user"
            class="mr-5"
            :deleteAction="authStore.deleteAccount" />

          <v-btn @click="changeName">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <div>
      <h1 class="mb-5">Rechnungen</h1>
      <v-data-table
        :headers="invoiceTableHeaders"
        :items="invoices"
        :hide-default-footer="invoices.length < 10">
        <template #item.actions="{ item }">
          <!-- <v-btn @click=""> -->
          <a
            v-if="item.hosted_invoice_url"
            :href="item.hosted_invoice_url"
            target="_blank"
            ><v-icon>mdi-open-in-new</v-icon></a
          >
          <!-- <v-btn
            @click="finalizeInvoice(item.id)"
            v-if="item.status === 'draft'">
            <v-icon>mdi-check</v-icon>
          </v-btn> -->
          <!-- </v-btn> -->
        </template>
      </v-data-table>
      <v-row style="margin-top: 15px">
        <v-spacer></v-spacer>
        <v-btn @click="openCustomerPortal">Zahlungsmethoden verwalten</v-btn>
      </v-row>
    </div>
    <h1 class="mb-5">Lizenzen</h1>
    <v-row>
      <v-col>
        <v-card
          width="400"
          min-height="400px">
          <v-card-title>Private Lizenz</v-card-title>
          <v-card-text>
            <span>{{ $t("views.licence.review." + ((personalLicence.pendingSwitch ? personalLicence.current_phase_mode : personalLicence.next_phase_mode) === "monthly" ? "monthlyCosts" : "yearlyCosts"), { costs: personalLicence.pendingSwitch ? personalLicence.currentPrice : personalLicence.price }) }}</span>
            <br />
            <v-alert
              v-if="personalLicence.pendingSwitch"
              class="mt-2 mb-2"
              density="compact"
              variant="tonal"
              type="info"
              icon="mdi-calendar-sync"
              data-cy="licence-pending-mode">
              {{
                $t(
                  "views.licence.other.pendingSwitchChip" +
                    (personalLicence.next_phase_mode === "yearly" ? "Yearly" : "Monthly"),
                  {
                    date: personalLicence.pendingDate,
                    costs: personalLicence.price
                  }
                )
              }}
            </v-alert>
            Module
            <ul class="ml-5">
              <template
                v-if="personalLicence.allModules"
                v-for="module in Object.keys(personalLicence.allModules)">
                <li v-if="personalLicence.allModules?.[module]">
                  {{ $t("views.licence.modules." + module + ".name") }}
                </li></template
              >
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              data-cy="edit-private-licence"
              @click="router.push({ name: 'licence-private' })">
              Bearbeiten
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <h1 class="mt-10 mb-5">Teams</h1>
    <v-row>
      <v-col v-for="organization in mainStore.organizations">
        <v-card data-cy="organization-card">
          <v-card-title>{{ organization.organization.name }}</v-card-title>
          <v-card-subtitle>{{
            organization.organization.description
          }}</v-card-subtitle>
          <v-card-text>
            <template v-if="Number(organization.licence_modules)">
              Deine Lizenz:
              <ul class="ml-5">
                <template v-for="module in mainStore.modules">
                  <li
                    v-if="module.value & Number(organization.licence_modules)">
                    {{ $t("views.licence.modules." + module.name + ".name") }}
                  </li></template
                >
              </ul>
            </template>
            <template v-else> Keine Module gewählt </template>
          </v-card-text>
          <v-card-actions v-if="organization.state === 0">
            <v-btn
              @click.stop="
                declineOrganizationInvite(organization.organization.id)
              "
              >Ablehnen</v-btn
            >
            <v-btn
              data-cy="accept-organization"
              @click.stop="
                acceptOrganizationInvite(organization.organization.id)
              "
              >Annehmen</v-btn
            >
          </v-card-actions>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="
              mainStore.organizationRights(organization.organization.id) &
              (ORGANIZATION_RIGHT_OWNER | ORGANIZATION_RIGHT_COOWNER)
            " data-cy="edit-organization" @click.stop="editOrganization(organization.organization.id)"
              >Bearbeiten</v-btn
            >
             <v-btn data-cy="leave-organization" @click="leaveOrganization(organization.organization.id)" v-if="organization.state !== 0 &&((mainStore.organizationRights(organization.organization.id) & ORGANIZATION_RIGHT_OWNER) === 0)">
                Verlassen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col>
        <v-btn
          data-cy="create-organization"
          @click="router.push({ name: 'organization-create' })"
          >Organization erstellen</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import { onMounted, Ref } from "vue";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useTranslation } from "i18next-vue";
import { useAuthStore } from "@/stores/authStore";
import axios from "axios";
import {
  MODULES,
  ORGANIZATION_RIGHT_COOWNER,
  ORGANIZATION_RIGHT_OWNER
} from "@/utils/constants";
import DeleteWithConfirmationButton from "@/components/tools/DeleteWithConfirmationButton.vue";
import { useMainStore } from "@/stores/mainStore";
import { getPhaseCosts } from "./Licence/moduleComposable";
import InvoiceAdressView from "@/components/dialogs/InvoiceAdressView.vue";
import { useSocketStore } from "@/stores/socketStore";
// import { organization } from "@/types/global";
import { useConfirm, useSnackbar } from "vuetify-use-dialog";

const { t } = useTranslation();
const createSnackbar = useSnackbar();
const personalLicence: Ref<Record<string, any>> = ref({});
const groupLicences = ref([]);

const router = useRouter();

const emit = defineEmits(["close"]);

const authStore = useAuthStore();
const mainStore = useMainStore();
const socketStore = useSocketStore();

const first_name = ref("");
const last_name = ref("");

const dialog_adress = ref(false);

const invoices = ref([]);
const invoiceTableHeaders = [
  {
    title: t("views.profile.invoicesTable.status"),
    key: "status",
    value: (item) => t("views.profile.invoices." + item.status)
  },
  {
    title: t("views.profile.invoicesTable.date"),
    key: "date",
    value: (item) =>
      new Date(
        (item.status === "draft"
          ? item.automatically_finalizes_at
          : item.effective_at) * 1000
      ).toLocaleDateString()
  },
  {
    title: t("views.profile.invoicesTable.time"),
    key: "time",
    value: (item) =>
      new Date(
        (item.status === "draft"
          ? item.automatically_finalizes_at
          : item.effective_at) * 1000
      ).toLocaleTimeString()
  },
  {
    title: t("views.profile.invoicesTable.amount"),
    key: "amount",
    value: (item) => item.amount_due / 100 + " " + t("units." + item.currency)
  },
  { title: t("views.profile.invoicesTable.actions"), value: "actions" }
];

onMounted(() => {
  first_name.value = authStore.user.first_name;
  last_name.value = authStore.user.last_name;
});

function changeName() {
  authStore.changeUserName(first_name.value, last_name.value);
  createSnackbar({
    text: t("actions.success.name"),
    showCloseButton: false,
    snackbarProps: { color: "success", timeout: 1000 }
  });
}

const dialogChangePassword = ref(false);
const oldPassword = ref("");
const newPassword = ref("");
const confirmPassword = ref("");

function editOrganization(id: number) {
  // edit organization
  router.push({ name: "organization", params: { id: id } });
}

const createConfirm = useConfirm();
function leaveOrganization(id) {
  createConfirm({
    dialogProps: { width: 400 },
    cardProps: { color: "error" },
    title: t("actions.confirmation.leave-organization.title"),
    content: t("actions.confirmation.leave-organization.content"),
    confirmationText: t("actions.confirmation.leave-organization.confirm"),
    cancellationText: t("actions.confirmation.leave-organization.cancel"),
    cancellationButtonProps: {
      // @ts-ignore
      "data-cy": "delete-cancel-button"
    },
    confirmationButtonProps: {
      color: "warning",
      // @ts-ignore
      "data-cy": "delete-confirm-button"
    }
  }).then((confirm) => {
    if (confirm) {
      mainStore.leaveOrganization(id).then(() => {
        createSnackbar({
          text: t("actions.confirmation.leave-organization.success"),
          showCloseButton: false,
          snackbarProps: { color: "success", timeout: 1000 }
        });
      });
    }
  });
}

function changePassword(accept: boolean) {
  if (!accept) {
    dialogChangePassword.value = false;
    return;
  }

  authStore
    .changePassword(oldPassword.value, newPassword.value, confirmPassword.value)
    .then((response) => {
      console.log("changePasswordSuccess", response);
      dialogChangePassword.value = false;
      createSnackbar({
        text: t("actions.success.password-changed"),
        showCloseButton: false,
        snackbarProps: { color: "success", timeout: 1000 }
      });
    })
    .catch((error) => {
      createSnackbar({
        text: t("responses." + error.response.data),
        showCloseButton: false,
        snackbarProps: { color: "error", timeout: 1000 }
      });
      console.error(error);
    });
}

function loadLicenses() {
  // load licenses
  axios.get("/api/licence/private").then((response) => {
    console.log(response.data);

    personalLicence.value = {
      currentModules: response.data.next_phase,
      allModules: response.data.current_phase,
      next_phase_mode: response.data.next_phase_mode,
      current_phase_mode: response.data.current_phase_mode,
      // switch of the payment mode saved, but the old mode still runs
      pendingSwitch:
        !!response.data.next_billing_cycle_anchor &&
        response.data.current_phase_mode !== response.data.next_phase_mode,
      pendingDate: new Date(
        (response.data.next_billing_cycle_anchor ?? 0) * 1000
      ).toLocaleDateString(),
      // monthEnd: response.data.removedModules,
      price: getPhaseCosts(
        response.data.next_phase,
        response.data.next_phase_mode,
        mainStore.modules,
        "name"
      ),
      currentPrice: getPhaseCosts(
        response.data.current_phase,
        response.data.current_phase_mode,
        mainStore.modules,
        "name"
      )
    };
  });
}

function acceptOrganizationInvite(organizationId: number) {
  mainStore.acceptOrganizationInvitation(
    organizationId,
    mainStore.loadOrganizations
  );
}

function declineOrganizationInvite(organizationId: number) {
  mainStore.declineOrganizationInvitation(organizationId).then(() => {
    mainStore.loadOrganizations();
  });
}

function loadInvoices() {
  axios.get("/api/stripe/invoices").then((response) => {
    console.log("Success", response.data);
    invoices.value = response.data;
  });
}

function finalizeInvoice(invoiceId: string) {
  axios.post(`/api/stripe/finalize-invoice`, { invoiceId }).then((response) => {
    console.log("Success", response.data);
    loadInvoices();
  });
}

socketStore.socket.on("payment-change", () => {
  console.log("payment-change Profile");
  loadInvoices();
  loadLicenses();
  mainStore.loadOrganizations();
});

function openCustomerPortal() {
  axios
    .get("/api/stripe/customer-portal")
    .then((response) => {
      window.open(response.data, "_blank");
    })
    .catch((err) => {
      createSnackbar({
        text: t(
          err.response?.status === 409
            ? "views.licence.other.noPaymentCustomer"
            : "actions.error-message"
        ),
        showCloseButton: false,
        snackbarProps: { color: "error", timeout: 2000 }
      });
    });
}

onMounted(() => {
  loadLicenses();
  loadInvoices();
  // a new organization is created before checkout, so the list can be outdated
  mainStore.loadOrganizations();
});
</script>
